const root = "SubmenuArticle-module_root_qedFZ1Fu";
const image = "SubmenuArticle-module_image_8e3JR3cL";
const title = "SubmenuArticle-module_title_6ZpMnNxD";
const description = "SubmenuArticle-module_description_A-0vIvs3";
const styles = {
  root,
  image,
  title,
  description
};
export {
  styles as default,
  description,
  image,
  root,
  title
};
